import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Personal = () => {
  useEffect(() => {
    AOS.refresh();
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 200,
    });
  }, []);

  return (
    <>
      <div className="personal-container">
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left" data-aos="fade-right">
            <h1 class="section-title highlight-gradient">DEBT CONSOLIDATION</h1>
            <p class="section-description ">
              Ready to regain control of your finances and reduce the stress of
              juggling multiple debts? A private loan for debt consolidation can
              streamline your payments and set you on the path to financial
              freedom.
            </p>
            <p class="section-description">
              Don't let debt hold you back—explore this option to see if it’s
              the right fit for you. Apply today to check your eligibility.
            </p>
          </div>

          <div class="debt-consolidation-right" data-aos="fade-left">
            <div class="feature-point">
              <h2 class="feature-title">Simplify your finances</h2>
              <p class="feature-text">
                Taking control of your finances starts with simplifying how you
                manage your debt. Rather than keeping up with multiple payments
                and varying interest rates, you'll only need to focus on a
                single, streamlined payment.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Save money</h2>
              <p class="feature-text">
                Consolidating your debt with a private loan could help you
                secure a lower interest rate—potentially saving you hundreds or
                even thousands of dollars over time.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Improve your credit score</h2>
              <p class="feature-text">
                Consistently making on-time payments and lowering your total
                debt can boost your credit score, making it easier to qualify
                for future loans and credit opportunities.
              </p>
            </div>
          </div>
        </div>
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left" data-aos="fade-up">
            <h1 class="section-title highlight-gradient">PERSONAL</h1>
            <p class="section-description ">
              Planning a special occasion like a wedding or dream vacation? Need
              support with student loans or other personal expenses? A private
              loan could be the ideal solution to help you make it happen.
            </p>
            <p class="section-description">
              Offering competitive interest rates and flexible repayment terms,
              a private loan from private lenders can give you the financial
              boost you need to turn your dreams into reality. Don’t let
              finances stand in the way—apply now to find out if you qualify.
            </p>
          </div>
        </div>
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left" data-aos="fade-left">
            <h1 class="section-title highlight-gradient">TAXES/CRA</h1>
            <p class="section-description ">
              If you're looking to ease the burden of unpaid taxes, explore
              private loan options to see if they're right for you. With 24-hour
              funding, flexible terms, and no income or credit checks, you may
              have more solutions available than you realize.
            </p>
            <p class="section-description">
              If you're aiming to get ahead of your tax debt, a private loan can
              help you avoid unwanted penalties and interest charges from the
              CRA. Additional benefits include protecting or improving your
              credit score and enhancing your financial stability. With a range
              of loan options and flexible repayment plans, you can find a
              solution that suits your budget and needs.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Personal;
